import {createContext} from "react";

export const InitialLoadContext = createContext<(() => void) | null>(null);
